import { render, staticRenderFns } from "./nice-tabs.vue?vue&type=template&id=ec91894a&scoped=true"
import script from "./nice-tabs.vue?vue&type=script&lang=js"
export * from "./nice-tabs.vue?vue&type=script&lang=js"
import style0 from "./nice-tabs.vue?vue&type=style&index=0&id=ec91894a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec91894a",
  null
  
)

export default component.exports